import React from 'react';
import Link from 'next/link';
import { RichText } from 'prismic-reactjs';
import { PrismicAwardProcess } from '../../types/prismic';
import styles from './grantProcess.module.scss';
import ProcessLineOne from './ProcessLineOne';

type Props = PrismicAwardProcess & {
  showProcessCta: boolean;
};

const GrantProcess = ({ data, showProcessCta }: Props) => {
  const {
    process_header,
    process_description,
    process_timeline,
    award_process_active,
    cta_link_url,
    cta_link_text,
    process_footer,
  } = data;

  // depending on whether this award also includes program details
  // we don't want to show the CTA button at the bottom of this component
  // instead, we'll show it at the bottom of the ProgramCurriculum component
  const show_cta_btn = award_process_active && showProcessCta;

  return (
    <>
      <article
        className={`inner-width inner-width-padding column center ${styles.processHolder}`}
      >
        {/* work on getting this to center properly */}
        <div className={`column center text-center ${styles.process}`}>
          <RichText render={process_header} />
          <RichText render={process_description} />

          <div className={styles.timeline}>
            <ProcessLineOne className={`${styles.timelineLine}`} />
            {process_timeline &&
              process_timeline.map((item, index) => {
                const mobileDescription =
                  item.mobile_description.length > 0
                    ? item.mobile_description
                    : item.description;
                return (
                  <div key={index} className={styles.timelineItem}>
                    <RichText render={item.date} />
                    <p className={`${styles.itemDescription}`}>
                      {item.description[0].text}
                    </p>
                    <p className={`${styles.itemMobDescription}`}>
                      {mobileDescription[0].text}
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
        {show_cta_btn && cta_link_url && cta_link_text && (
          <Link href={cta_link_url[0].text}>
            <a className="button secondary no-arrow invert">
              {cta_link_text[0].text}
            </a>
          </Link>
        )}
        {process_footer && <RichText render={process_footer} />}
      </article>
    </>
  );
};

export default GrantProcess;
